import { BaseStore } from 'fluxible/addons';

class ContestFinalistStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);

        this.finalists = [];
        this.maxFinalists = 6;
        this.persistFinalistUrl = '';
        this.confirmFinalistsUrl = '';
        this.prizeGuaranteed = false;
        this.shortlistStage = false;
        this.timeLeft = null;
    }

    initialise(state) {
        this.finalists = state.finalists;
        this.maxFinalists = state.maxFinalists;
        this.persistFinalistUrl = state.persistFinalistUrl;
        this.confirmFinalistsUrl = state.confirmFinalistsUrl;
        this.prizeGuaranteed = state.prizeGuaranteed;
        this.shortlistStage = state.shortlistStage;
        this.timeLeft = state.timeLeft;
        this.emitChange();
    }

    getPersistFinalistUrl() {
        return this.persistFinalistUrl;
    }

    getConfirmFinalistsUrl() {
        return this.confirmFinalistsUrl;
    }

    addFinalist(finalist) {
        if (!this.isFinalist(finalist.userId) && !this.hasSelectedMaxFinalists()) {
            this.finalists = [...this.finalists, finalist];
            this.emitChange();
        }
    }

    removeFinalist(userId) {
        this.finalists = this.finalists.filter((user) => user.userId != userId);
        this.emitChange();
    }

    getFinalists() {
        return this.finalists;
    }

    getMaxFinalists() {
        return this.maxFinalists;
    }

    hasSelectedMaxFinalists() {
        return this.finalists.length >= this.maxFinalists;
    }

    isFinalist(userId) {
        return this.finalists.some((user) => user.userId == userId);
    }

    isPrizeGuaranteed() {
        return this.prizeGuaranteed;
    }

    isShortlistStage() {
        return this.shortlistStage;
    }

    getTimeLeft() {
        return this.timeLeft;
    }
}

ContestFinalistStore.storeName = 'ContestFinalistStore';

ContestFinalistStore.handlers = {
    ADD_FINALIST: 'addFinalist',
    REMOVE_FINALIST: 'removeFinalist',
};

export default ContestFinalistStore;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/stores/contest-finalist-store.js